import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-director',
  templateUrl: './director.component.html',
  styleUrls: ['./director.component.less']
})
export class DirectorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
